export abstract class Entity {

    id: number;

    abstract getEndpointName(): string;

}
